import React, { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

const FIELDS = [
  { key: "address", label: "Indirizzo", placeholder: "Plinganserstraße 38A, 81369 München" },
  { key: "phone", label: "Telefono", placeholder: "+49 89 74746299" },
  { key: "email", label: "Email", placeholder: "info@caffecucinasorriso.de" },
  { key: "instagram", label: "Instagram (URL)", placeholder: "https://instagram.com/..." },
  { key: "facebook", label: "Facebook (URL)", placeholder: "https://facebook.com/..." },
  { key: "maps_url", label: "Google Maps (URL embed)", placeholder: "https://www.google.com/maps?q=...&output=embed" },
];

const empty = { address: "", phone: "", email: "", instagram: "", facebook: "", maps_url: "" };

const ContactManager = ({ authedAxios }) => {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await authedAxios().get("/settings/contact");
        setForm({ ...empty, ...(res.data || {}) });
      } catch {
        toast.error("Errore caricamento contatti");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [authedAxios]);

  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      const res = await authedAxios().put("/settings/contact", form);
      setForm({ ...empty, ...(res.data || {}) });
      toast.success("Contatti aggiornati");
    } catch {
      toast.error("Errore salvataggio contatti");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section data-testid="admin-contact-section" className="mb-14">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-6">
        <div>
          <p className="overline text-[color:var(--wine)] flex items-center">
            <span className="section-line"></span>
            Contatti del locale
          </p>
          <h2 className="mt-4 font-serif-display text-3xl">Indirizzo & contatti.</h2>
        </div>
        <button
          type="button"
          onClick={save}
          disabled={saving || loading}
          data-testid="contact-save"
          className="btn-primary disabled:opacity-50"
          style={{ padding: "0.6rem 1.2rem" }}
        >
          <Save size={14} strokeWidth={1.6} />
          {saving ? "Salvataggio..." : "Salva contatti"}
        </button>
      </div>

      {loading ? (
        <p className="text-[color:var(--ink-3)]">Caricamento...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {FIELDS.map((f) => (
            <div key={f.key} className={f.key === "maps_url" ? "md:col-span-2" : ""}>
              <Label className="overline text-[color:var(--ink-3)]">{f.label}</Label>
              <Input
                value={form[f.key] || ""}
                onChange={update(f.key)}
                data-testid={`contact-field-${f.key}`}
                placeholder={f.placeholder}
                className="mt-1 rounded-none border-0 border-b border-[color:var(--line)] bg-transparent focus-visible:ring-0 focus-visible:border-[color:var(--wine)] px-0"
              />
            </div>
          ))}
        </div>
      )}
      <p className="mt-4 text-xs text-[color:var(--ink-3)] italic">
        Il link Google Maps deve terminare con &quot;&amp;output=embed&quot; per apparire correttamente nella mappa del sito.
      </p>
    </section>
  );
};

export default ContactManager;
